module.exports = __webpack_public_path__ + "media/images/burger-menu2-32aab5fa.svg";